import * as React from 'react';
import { observer } from 'mobx-react';
import { mobileDeviceFullStore } from '../store/store';
import { Label } from 'office-ui-fabric-react/lib/Label';
import strings from 'owa-strings/owa-options-strings';

@observer
export default class MobileDeviceLogging extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                {mobileDeviceFullStore().isLoggingEnabled ? (
                    <Label>{strings.options_mobile_logging_enableLabel}</Label>
                ) : (
                    <Label>{strings.options_mobile_logging_disableLabel}</Label>
                )}
            </div>
        );
    }
}
